export const ReportView = {
  Chart: "chart",
  Table: "table"
};
